import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Input, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from "../../components/ParadigmaDatePicker/ParadigmaDatePicker";

import TableDirecciones from './TableDirecciones';
import TableTelefonos from './TableTelefonos';
import TableMails from './TableMails.js';
import ModalRichTextEditor from './ModalRichTextEditor';

import TableArchivos from '../Loteos/TableArchivos';

import moment from 'moment';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nombre: '',
            apellido: '',
            encabezado_id: null,
            descripcion: '',
            tipoDocumento_id: null,
            nroDocumento: '',
            cuil: '',
            nacionalidad_id: null,
            estadoCivil_id: null,
            direcciones: [],
            telefonos: [],
            emails: [],
            activeTab: 1,
            documentosClientes: [],
            notificacionesPorDeudas:false,
            fechaNacimiento: moment(),
            genero: null,
            nroFolio: '',
            activeFolio: false, //Solo para divorciados
            postVariables: [
                 'notificacionesPorDeudas',
                'nombre',
                'apellido',
                'encabezado_id',
                'descripcion',
                'tipoDocumento_id',
                'nroDocumento',
                'cuil',
                'genero',
                'nroFolio',
            ],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    configuraciones = {};

    componentWillMount() {
        if (this.props.action === 'CREATE') {
            try {
                this.configuraciones = JSON.parse(localStorage.configuraciones);
                if (this.configuraciones) {
                    const tipoDocumento_id = this.configuraciones.tipoDeDocumento ? this.configuraciones.tipoDeDocumento.id : null;
                    this.setState({ tipoDocumento_id });
                }
            } catch(err) {
                // Sin configuracion
            }
        }
    }

    resetForm() {
        const tipoDocumento_id = this.configuraciones && this.configuraciones.tipoDeDocumento ? this.configuraciones.tipoDeDocumento.id : null;
        this.setState({
            nombre: '',
            apellido: '',
            encabezado_id: null,
            descripcion: '',
            tipoDocumento_id:null,
            nroDocumento: '',
            cuil: '',
            nacionalidad_id: null,
            notificacionesPorDeudas:false,
            estadoCivil_id: null,
            direcciones: [],
            telefonos: [],
            emails: [],
            activeTab: 1,
            documentosClientes: [],
            fechaNacimiento: moment(),
            genero: null,
            nroFolio: '',
            activeFolio: false,
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data['estadoCivil_id'] = (this.state.estadoCivil_id) ? (this.state.estadoCivil_id) : ('');
        data['nacionalidad_id'] = (this.state.nacionalidad_id) ? (this.state.nacionalidad_id) : ('');

        data.direcciones = this.state.direcciones.map(dir => {
            let direccion = {
                direccion: dir.direccion,
                numero: (dir.numero!='') ? (dir.numero) : (null),
                piso: dir.piso,
                descripcion: dir.descripcion,
                localidad_id: dir.localidad_id
            };
            if (dir.id) direccion.id = dir.id;
            return direccion;
        });

        data.telefonos = this.state.telefonos.map(tel => {
            let telefono = {
                telefono: tel.telefono,
                descripcion: tel.descripcion,
            };
            if (tel.id) telefono.id = tel.id;
            return telefono;
        });

        data.emails = this.state.emails.map(em => {
            let email = {
                email: em.email,
                descripcion: em.descripcion
            };
            if (em.id) email.id = em.id;
            return email;
        });

        data.documentos = this.state.documentosClientes.map(p => p.id ? { id: p.id } : { archivo: p.archivo });
        data.fechaNacimiento = (this.state.fechaNacimiento) ? (moment(this.state.fechaNacimiento).format('YYYY-MM-DD')) : (moment());

        return data;
    }

    setData(data) {
        if (this.props.action === 'CREATE') {
            return this.setState({
                tipoDocumento_id: data.tipoDeDocumento ? data.tipoDeDocumento.id : null
            });
        }
        if (data.success) {
            this.setState({
                nombre: data.nombre,
                apellido: data.apellido,
                encabezado_id: data.encabezado.id,
                notificacionesPorDeudas:data.notificacionesPorDeudas,
                descripcion: data.descripcion,
                tipoDocumento_id: data.tipoDocumento.id,
                nroDocumento: data.nroDocumento,
                cuil: data.cuil,
                nacionalidad_id: (data.nacionalidad) ? (data.nacionalidad.id) : (null),
                estadoCivil_id: (data.estadoCivil) ? (data.estadoCivil.id) : (null),
                direcciones: data.direcciones.map(dir => ({
                    ...dir,
                    localidad_id: dir.localidad.id,
                    provincia_id: dir.localidad.provincia.id,
                    ciudad: dir.localidad.nombre
                })),
                telefonos: data.telefonos,
                emails: data.emails,
                documentosClientes: (data.documentos) ? (data.documentos)  : ([]),
                fechaNacimiento: (data.fechaNacimiento) ? moment(data.fechaNacimiento) : moment(),
                genero: data.genero ? data.genero : null,
                nroFolio: data.nroFolio,
                activeFolio: (data.estadoCivil) ? (data.estadoCivil.nombre.includes('Divorciad')) : (false),
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Cliente",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Cliente ha sido creado con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Cliente",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Cliente ha sido editado con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Cliente",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Cliente",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Cliente ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: 'Eliminar',
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    setConfigData = () => {
        const { action } = this.props;

        if (action === 'CREATE') {
            try {
                const config = localStorage.configuraciones ? JSON.parse(localStorage.configuraciones) : null;
                if (config && config.tipoDeDocumento_id) {
                    this.setState({ tipoDocumento_id: config.tipoDeDocumento_id });
                }
            } catch(e) {
                console.error(e);
            }
        }
    }

    render() {
        const { action } = this.props;
        const {
            activeTab,
            encabezado_id,
            apellido,
            nombre,
            nacionalidad_id,
            fechaNacimiento,
            tipoDocumento_id,
            nroDocumento,
            cuil,
            estadoCivil_id,
            activeFolio,
            nroFolio,
            genero,
            notificacionesPorDeudas,
            descripcion,
            direcciones,
            telefonos,
            emails,
            documentosClientes,
        } = this.state;
        let vars = this.modalVars();
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.clientes.clientes : null)}
                submitUrl={(vars.submitType ? api.clientes.clientes : null)}
                submitType={vars.submitType}
                id={vars.id}

                onOpen={this.setConfigData}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                className="ui-paradigma-modal ui-client-modal ui-modal-with-tabs"

                forceDelete

                fileUploader
            >
                <Nav tabs className="ui-modal-tabs">
                    <NavItem>
                        <NavLink
                            className={(activeTab == 1 ? 'active' : '')}
                            onClick={() => { this.setState({ activeTab: 1 }) }}
                        >General</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={(activeTab == 2 ? 'active' : '')}
                            onClick={() => { this.setState({ activeTab: 2 }) }}
                        >Archivos</NavLink>
                    </NavItem>
                </Nav>

                <TabContent
                    activeTab={activeTab}
                    className="ui-modal-tab-content"
                >
                    <TabPane tabId={1}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Datos personales</p>
                            <div className="ui-form-grid">
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Apellido"}
                                    error={() => this.getError('encabezado_id') || this.getError('apellido')}
                                    inputComponent={
                                        <div className="ui-composite-field">
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                url={api.configuracion.encabezados}
                                                parameters={{
                                                    paginationEnabled:false,
                                                }}
                                                displayField="siglas"
                                                disabled={vars.disabled}
                                                value={encabezado_id}
                                                onChange={data => this.onChangeField('encabezado_id', (data)? data.id: null)}
                                            />
                                            <Input
                                                disabled={vars.disabled}
                                                maxLength={100}
                                                value={apellido}
                                                onChange={e => this.onChangeField('apellido', e.target.value)}
                                            />
                                        </div>
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Documento"}
                                    error={() => this.getError('tipoDocumento_id') || this.getError('nroDocumento')}
                                    inputComponent={
                                        <div className="ui-composite-field ui-composite-field-document">
                                            <ParadigmaAsyncSeeker
                                                clearable={false}
                                                url={api.configuracion.tiposdedocumento}
                                                parameters={{
                                                    paginationEnabled:false,
                                                }}
                                                displayField="abreviatura"
                                                disabled={vars.disabled}
                                                value={tipoDocumento_id}
                                                onChange={data => this.onChangeField('tipoDocumento_id', (data)? data.id: null)}
                                            />
                                            <Input
                                                disabled={vars.disabled}
                                                maxLength={15}
                                                value={nroDocumento}
                                                onChange={e => {
                                                    e.persist();
                                                    this.setState(prevState => ({
                                                        nroDocumento: /^\d*$/.test(e.target.value) ? e.target.value : prevState.nroDocumento
                                                    }));
                                                }}
                                            />
                                        </div>
                                    }
                                />

                                <ParadigmaLabeledInput
                                    disabled={vars.disabled}
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Nombre"}
                                    maxLength={100}
                                    value={nombre}
                                    onChange={e => this.onChangeField('nombre', e.target.value)}
                                    error={() => this.getError('nombre')}
                                />

                                <ParadigmaLabeledInput
                                    disabled={vars.disabled}
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"CUIL"}
                                    maxLength={11}
                                    value={cuil}
                                    onChange={e => {
                                        e.persist();
                                        this.setState(prevState => ({
                                            cuil: /^\d*$/.test(e.target.value) ? e.target.value : prevState.cuil
                                        }));
                                    }}
                                    error={() => this.getError('cuil')}
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Nacionalidad"}
                                    error={() => this.getError('nacionalidad_id') || this.getError('nacionalidad')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            url={api.geograficas.nacionalidades}
                                            parameters={{
                                                paginationEnabled:false,
                                                sort:['nombre']
                                            }}
                                            disabled={vars.disabled}
                                            value={nacionalidad_id}
                                            onChange={data => this.onChangeField('nacionalidad_id', (data)? data.id: null)}
                                        />
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Estado Civil"}
                                    error={() => this.getError('estadoCivil_id') || this.getError('estadoCivil')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            url={api.configuracion.estadocivil}
                                            parameters={{
                                                paginationEnabled:false,
                                                sort:['nombre']
                                            }}
                                            disabled={vars.disabled}
                                            value={estadoCivil_id}
                                            onChange={data => {this.onChangeField('estadoCivil_id', (data) ? data.id: null); 
                                                                this.onChangeField('activeFolio',(data) ? (data.nombre.includes('Divorciad')) : (false))
                                                                if(data && !data.nombre.includes('Divorciad')){
                                                                    this.onChangeField('nroFolio','')
                                                                }
                                        }}
                                        />
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Fecha Nac."}
                                    error={() => this.getError('fechaNacimiento')}
                                    inputComponent={
                                        <div className="ui-date-age-field">
                                            <ParadigmaDatePicker
                                                disabled={vars.disabled}
                                                value={fechaNacimiento}
                                                onChange={data => this.onChangeField('fechaNacimiento', data)}
                                            />
                                            <span className="ui-inline-field-label">Edad</span>
                                            <Input
                                                disabled={true}
                                                maxLength={100}
                                                value={moment().diff(fechaNacimiento, 'years')}
                                            />
                                        </div>
                                    }
                                />

                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"Género"}
                                    error={() => this.getError('genero')}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            url={undefined}
                                            optionDefault={[{nombre: 'Hombre', id: 'H'}, {nombre: 'Mujer', id: 'M'}, {nombre: 'Otro', id: 'O'}]}
                                            disabled={vars.disabled}
                                            value={genero}
                                            onChange={data => this.onChangeField('genero', (data) ? data.id : null)}
                                        />
                                    }
                                />

                                {activeFolio && 
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    label={"N° Folio"}
                                    maxLength={'50'}
                                    error={() => this.getError('nroFolio')}
                                    value={nroFolio}
                                    onChange={data => this.onChangeField('nroFolio', data.target.value)}
                                />}

                                <div className={activeFolio ? "" : "ui-span-2"}>
                                    <label className="ui-checkbox-row">
                                        <span>NO notificar por cuotas que adeuda</span>
                                        <input
                                            type="checkbox"
                                            checked={notificacionesPorDeudas == false}
                                            disabled={vars.disabled}
                                            onChange={() => this.onChangeField('notificacionesPorDeudas', !notificacionesPorDeudas)}
                                        />
                                    </label>
                                </div>
                            </div>
                        </section>

                        <section className="ui-modal-section">
                            <p className="ui-section-label">Descripción</p>
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Descripción"}
                                error={() => this.getError('descripcion')}
                                inputComponent={
                                    <ModalRichTextEditor
                                        value={descripcion}
                                        onSubmit={data => this.onChangeField('descripcion', data)}
                                        disabled={['DETAIL', 'DELETE'].includes(this.props.action)}
                                    />
                                }
                            />
                        </section>

                        <div className="ui-contact-grid">
                            <section className="ui-modal-section ui-contact-card">
                                <p className="ui-section-label">Direcciones</p>
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    error={() => this.getError('direcciones')}
                                    inputComponent={
                                        <TableDirecciones
                                            action={this.props.action}
                                            direcciones={direcciones}
                                            onChange={direcciones => this.setState({ direcciones })}
                                        />
                                    }
                                />
                            </section>

                            <section className="ui-modal-section ui-contact-card">
                                <p className="ui-section-label">Teléfonos</p>
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    error={() => this.getError('telefonos')}
                                    inputComponent={
                                        <TableTelefonos
                                            action={this.props.action}
                                            telefonos={telefonos}
                                            onChange={telefonos => this.setState({ telefonos })}
                                        />
                                    }
                                />
                            </section>

                            <section className="ui-modal-section ui-contact-card">
                                <p className="ui-section-label">Mails</p>
                                <ParadigmaLabeledInput
                                    md={[12, 12]}
                                    classNames={["ui-field-label-col", "ui-field-control-col"]}
                                    error={() => this.getError('emails')}
                                    inputComponent={
                                        <TableMails
                                            action={this.props.action}
                                            mails={emails}
                                            onChange={emails => this.setState({ emails })}
                                        />
                                    }
                                />
                            </section>
                        </div>

                    </TabPane>

                    <TabPane tabId={2}>
                        <section className="ui-modal-section">
                            <p className="ui-section-label">Nuevos archivos</p>
                            <TableArchivos
                                action={action}
                                archivos={documentosClientes}
                                onChange={documentosClientes => this.onChangeField('documentosClientes', documentosClientes)}
                                url={api.clientes.clientesdocumentos.replace('$id_cliente', (this.props.id) ? (this.props.id()) : (''))}
                            />
                        </section>

                    </TabPane>


                </TabContent>

            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Clientes/Modal.js